import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileActionBar from "@/components/MobileActionBar";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Realisations from "@/pages/Realisations";
import APropos from "@/pages/APropos";
import Devis from "@/pages/Devis";
import Contact from "@/pages/Contact";
import { MentionsLegales, Confidentialite, Cookies } from "@/pages/Legal";
import Admin from "@/pages/Admin";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);
}

function Shell() {
  useLenis();
  return (
    <div className="min-h-screen bg-[#F6F3EB]">
      <ScrollManager />
      <Header />
      <main className="pb-16 md:pb-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/devis" element={<Devis />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      <Footer />
      <MobileActionBar />
      <ChatWidget />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#121212",
            color: "#F6F3EB",
            border: "1px solid #33353B",
            borderRadius: "2px",
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: "12px",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
